import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  TextField,
  Modal,
  Card,
  CardContent,
  CardActions,
  ButtonBase,
  Grid,
  Avatar,
  Tooltip,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import ReplyIcon from "@mui/icons-material/Reply";
import DeleteIcon from "@mui/icons-material/Delete";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import Picker from "@emoji-mart/react";
import data from "@emoji-mart/data";
import axios from "axios";
import Swal from "sweetalert2";
import EditIcon from '@mui/icons-material/Edit';

import Quill from "quill";

const ShowAllPost = () => {
  const { id } = useParams();
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [CatName, setCatName] = useState("");
  const [categoryId, setCategoryId] = useState(id);
  const [posts, setPosts] = useState([]);
  const [repliesData, setRepliesData] = useState({}); // Store replies data
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const userDataString = localStorage.getItem("Login_User_Community_All_Data");
  const userData = JSON.parse(userDataString);
  const roleId = userData.role;
  const [PostCatiId, setPostCatiId] = useState("");
  const [PostId, setPostId] = useState("");
  const [emojiPickerOpen, setEmojiPickerOpen] = useState(false); // Emoji picker state

  const [isEdit, setIsEdit] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
 


  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const categoryResponse = await axios.get(
          `${API_BASE_URL}/api/getCategoryById/${id}`
        );
        setCatName(categoryResponse.data.name); // Assuming `data.name` is the category name
      } catch (error) {
        console.error("Error fetching category:", error);
      }
    };

    fetchCategory(); // Call the async function
  }, [id]);

  useEffect(() => {
    const fetchCategoryDetails = async () => {
      try {
        const userDataString = localStorage.getItem(
          "Login_User_Community_Details"
        );
        const token = JSON.parse(userDataString);
        //console.log("token===",token);
        if (!token) {
          console.error("Token is missing. Redirecting to login.");
          navigate("/login");
          return;
        }
        const postsResponse = await axios.get(
          `${API_BASE_URL}/api/posstGetByID/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (!postsResponse.data || postsResponse.data.length === 0) {
          console.warn("No posts found for this ID.");
          setPosts([]);
          setMessage("No posts found.");
          return;
        }
        setPosts(postsResponse.data);
        setPostId(postsResponse.data[0]?.id || null);
        setMessage("");

        setCategoryName(postsResponse.data.name);

        // Fetch reply data for each post
        const repliesResponse = await Promise.all(
          postsResponse.data.map(async (post) => {
            try {
              const response = await axios.get(
                `${API_BASE_URL}/api/getReplies/${post.id}`,
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                }
              );
              return { postId: post.id, data: response.data };
            } catch (error) {
              // Handle cases where replies API returns an error
              console.error(
                `Error fetching replies for post ID ${post.id}:`,
                error.message
              );
              // return { postId: post.id, data: { user_count: 0, user_initials: "" } };
              return { postId: post.id, data: [] }; // Return an empty array for missing replies
            }
          })
        );

        const replies = repliesResponse.reduce((acc, reply) => {
          acc[reply.postId] = reply.data || {
            user_count: 0,
            user_initials: "",
          };
          return acc;
        }, {});

        setRepliesData(replies);
      } catch (error) {
        if (error.response && error.response.status === 404) {
          setMessage(error.response.data.message); // Set the API message
          setPosts([]);
        } else {
          console.error("Error fetching data:", error.message);
        }
      }
    };

    fetchCategoryDetails();
  }, [id, navigate]);

  // const handlePost = async () => {
  //   const userId = userData.id;
  //   // const removeHtmlTags = (str) => str.replace(/<\/?[^>]+(>|$)/g, "");
  //   const newPost = {
  //     cat_id: id,
  //     title: title,
  //     // post_details:  removeHtmlTags(content),
  //     post_details: content,
  //     user_id: userId,
  //   };

  //   try {
  //     const userDataString = localStorage.getItem(
  //       "Login_User_Community_Details"
  //     );
  //     const token = JSON.parse(userDataString);

  //     if (!token) {
  //       console.error("Token is missing. Redirecting to login.");
  //       navigate("/login");
  //       return;
  //     }
  //     const response = await axios.post(
  //       "http://localhost:8000/api/postSave",
  //       newPost,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     setPosts((prevPosts) => [response.data, ...prevPosts]);

  //     setTitle("");
  //     setContent("");
  //     setContent("");
  //     setOpen(false);
  //   } catch (error) {
  //     console.error(
  //       "Error saving post:",
  //       error.response?.data || error.message
  //     );
  //   }
  // };

  const handlePost = async () => {
    const userId = userData.id;
  
    // Construct the post data
    const postData = {
      cat_id: id,
      title: title,
      post_details: content,
      user_id: userId,
    };
  
    try {
      const userDataString = localStorage.getItem("Login_User_Community_Details");
      const token = JSON.parse(userDataString);
  
      if (!token) {
        console.error("Token is missing. Redirecting to login.");
        navigate("/login");
        return;
      }
  
      let response;
      if (isEdit) {
        // If editing, make a PUT request to update the post
        if (userData.role_id === 1) {
          const { user_id, ...remainingPostData } = postData; // Exclude user_id
          postData = remainingPostData;
        }
        response = await axios.put(
          `${API_BASE_URL}/api/postUpdate/${selectedPost.id}`, // Assuming `selectedPost` holds the post being edited
          postData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        
        // Update the local state with the updated post
        setPosts((prevPosts) =>
          prevPosts.map((post) =>
            post.id === selectedPost.id ? { ...post, ...response.data } : post
          )
        );

      } else {
        // If creating, make a POST request to save the new post
        response = await axios.post(
          `${API_BASE_URL}/api/postSave`,
          postData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
  
        // Add the new post to the local state
        setPosts((prevPosts) => [response.data, ...prevPosts]);
      }
  
      // Clear form fields and close the modal
      setTitle("");
      setContent("");
      setOpen(false);
      setIsEdit(false);
      setSelectedPost(null);
    } catch (error) {
      console.error("Error saving post:", error.response?.data || error.message);
    }
  };
  

  const handleViewDetails = (pryid) => {
    if (roleId == "3") {
      navigate(`/provider-user/post-details/${pryid}`);
    }else if (roleId == "2") {
      navigate(`/patient-user/post-details/${pryid}`);
    }else if (roleId == "1") {
      navigate(`/admin-user/post-details/${pryid}`);
    }else if (roleId == "4") {
      navigate(`/vendor-user/post-details/${pryid}`);
    } else {
      navigate(`/admin-user/post-details/${pryid}`);
    }
  };

  const handleOpenModal = async () => {
    try {
      const categoryResponse = await axios.get(
        `${API_BASE_URL}/api/getCategoryById/${id}`
      );
      setCategoryName(categoryResponse.data.name);

      setOpen(true);
    } catch (error) {
      console.error("Error fetching category name:", error);
    }
  };

  const handleOpenEmojiPicker = () => {
    setEmojiPickerOpen((prev) => !prev);
  };

  const addEmoji = (emoji) => {
    setContent((prevContent) => prevContent + emoji.native);
  };

  const modules = {
    toolbar: [
      // Basic text formatting
      [{ header: [1, 2, 3, false] }], // Headings
      ["bold", "italic", "underline", "strike"], // Bold, Italic, Underline, Strikethrough
      [{ list: "ordered" }, { list: "bullet" }], // Numbered and Bulleted lists
      [{ indent: "-1" }, { indent: "+1" }], // Indentation
      ["blockquote", "code-block"], // Blockquote and Code block
      ["link", "image", "video"], // Embed links, images, and videos
      [{ color: [] }, { background: [] }], // Text and background colors
      [{ align: [] }], // Align text
      ["clean"], // Remove formatting
      //["emoji-picker"],
    ],
    // handlers: {
    //   "emoji-picker": handleOpenEmojiPicker
    // },
  };

  const handleDelete = (id) => {
    const userDataString = localStorage.getItem("Login_User_Community_Details");
    const token = JSON.parse(userDataString);
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this action!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${API_BASE_URL}/api/posts/${id}`, {
            headers: {
              Authorization: `Bearer ${token}`, // Replace with your token
            },
          })
          .then((response) => {
            Swal.fire("Deleted!", response.data.message, "success");

            // Update the local state to remove the deleted user
            //setUsers((prevUsers) => prevUsers.filter((user) => user.id !== id));
            setPosts((prevPosts) => prevPosts.filter((post) => post.id !== id));

          })
          .catch((error) => {
            Swal.fire("Error!", "Something went wrong.", "error");
            console.error("Error deleting user:", error);
          });
      }
    });
  };

  const handleEdit = (postId) => {
    const post = posts.find((p) => p.id === postId);
    //console.log("post Data",post);
    if (post) {
      setSelectedPost(post);
      setTitle(post.title);
      setCategoryName(CatName); // Assuming this field exists in `post`
      setContent(post.post_details); // Assuming this field exists in `post`
      setIsEdit(true);
      setOpen(true);
    }
  };

  return (
    <Box sx={{ backgroundColor: "#f5f5f5", minHeight: "100vh" }}>
      <AppBar position="static" sx={{ backgroundColor: "#2196f3" }}>
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            Topic {CatName && ` - ${CatName}`}
          </Typography>
          {(roleId === "3" || roleId === "1" || roleId === "4") && (
            <Button color="inherit" onClick={handleOpenModal}>
              Create New Topic
            </Button>
          )}
        </Toolbar>
      </AppBar>

      <Box sx={{ maxWidth: "1200px", margin: "20px auto", padding: "10px" }}>
        {message ? (
          <Typography variant="h6" color="textSecondary" align="center">
            {message}
          </Typography>
        ) : posts.length === 0 ? (
          <Typography variant="h6" color="textSecondary" align="center">
            No posts available for this category.
          </Typography>
        ) : (
          posts.map((post) => {
            const replyData = repliesData[post.id] || {};
            const { user_count, user_initials } = replyData;

            return (
              <ButtonBase
                key={post.id}
                onClick={() => handleViewDetails(post.id)}
                sx={{ width: "100%", display: "block", textAlign: "left" }}
              >
                <Card
                  sx={{
                    marginBottom: "15px",
                    width: "100%",
                    boxShadow: 3,
                    "&:hover": { boxShadow: 6 },
                  }}
                >
                  <CardContent>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Grid container spacing={2}>
                        {/* 8-Column Section */}
                        <Grid item xs={12} sm={9}>
                          <Box>
                            <Typography
                              variant="h6"
                              sx={{ fontWeight: "bold" }}
                            >
                              {post.title}
                            </Typography>
                          </Box>
                        </Grid>

                        {/* 4-Column Section */}
                        <Grid
                          item
                          xs={12}
                          sm={2}
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            {/* {user_count && (
                              <Typography variant="body2" sx={{ marginRight: "40px" }}>
                                {user_count}
                              </Typography>
                            )} */}
                            {user_initials && (
                              <Box
                                sx={{ display: "flex", marginRight: "10px" }}
                              >
                                {user_initials
                                  .replace(/[^a-zA-Z]/g, "") // Remove non-alphabet characters like commas and spaces
                                  .split("")
                                  .map((letter, index) => {
                                    // Generate a random color for each letter
                                    const randomColor = `hsl(${
                                      Math.random() * 360
                                    }, 100%, 70%)`; // Random color using HSL

                                    return (
                                      <Avatar
                                        key={index}
                                        sx={{
                                          bgcolor: randomColor, // Apply random color
                                          marginRight: "5px", // Space between Avatars
                                          fontWeight: "bold",
                                          width: 24, // Size of Avatar
                                          height: 24, // Size of Avatar
                                          fontSize: 14, // Size of text inside Avatar
                                        }}
                                      >
                                        {letter}
                                      </Avatar>
                                    );
                                  })}
                              </Box>
                            )}
                          </Box>
                        </Grid>
                        {roleId === "1" && (
                        <Grid item xs={12} sm={1}>
                          <Box>
                            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                              <DeleteIcon
                                sx={{ color: "#555", cursor: "pointer" }}
                                onClick={(event) => {
                                  event.stopPropagation(); // Prevent click event from propagating
                                  handleDelete(post.id);
                                }}
                              />
                              <EditIcon
                                sx={{ color: "#555", cursor: "pointer" }}
                                onClick={(event) => {
                                  event.stopPropagation(); // Prevent click event from propagating
                                  handleEdit(post.id);
                                }}
                              />
                            </Typography>
                          </Box>
                        </Grid>
                        )}
                      </Grid>
                    </Box>
                  </CardContent>
                </Card>
              </ButtonBase>
            );
          })
        )}
      </Box>

      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 800,
            height: 500,
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 2,
            p: 4,
          }}
        >
          <Typography variant="h6" sx={{ marginBottom: "15px" }}>
            {isEdit ? "Edit Post" : "Create New Post"}
          </Typography>
          <TextField
            label="Title"
            variant="outlined"
            fullWidth
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            sx={{ marginBottom: "15px" }}
          />
          <TextField
            label="Category Name"
            variant="outlined"
            fullWidth
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
            sx={{ marginBottom: "15px" }}
            disabled
          />
          <ReactQuill
            value={content}
            onChange={setContent}
            placeholder="Start typing here..."
            style={{
              marginBottom: "20px",
              background: "#fff",
              borderRadius: "5px",
              height: "170px",
            }}
            modules={modules}
            theme="snow"
          />
          <Button variant="contained" fullWidth onClick={handlePost} style={{ marginTop: "30px" }}>
            {isEdit ? "Update Post" : "Post"}
          </Button>
        </Box>
      </Modal>


      {/* <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 800,
            height: 500,
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 2,
            p: 4,
          }}
        >
          <Typography variant="h6" sx={{ marginBottom: "15px" }}>
            Create New Post
          </Typography>
          <TextField
            label="Title"
            variant="outlined"
            fullWidth
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            sx={{ marginBottom: "15px" }}
          />
          <TextField
            label="Category Name"
            variant="outlined"
            fullWidth
            value={categoryName}
            disabled
            sx={{ marginBottom: "15px" }}
          />

          <ReactQuill
            value={content}
            onChange={setContent}
            placeholder="Start typing here..."
            style={{
              marginBottom: "20px",
              background: "#fff",
              borderRadius: "5px",
              height: "170px",
            }}
            modules={modules}
            theme="snow"
          />

          <Button
            variant="contained"
            fullWidth
            onClick={handlePost}
            style={{ marginTop: "30px" }}
          >
            Post
          </Button>
        </Box>
      </Modal> */}
    </Box>
  );
};

export default ShowAllPost;

